module.exports = __webpack_public_path__ + "img/8016.f435502d.gif";